module.exports = __webpack_public_path__ + "img/type-ico.489ed869.svg";